import { useQuery } from '@tanstack/vue-query';
import type { NotificationCategoryKey } from '~/api/queries/useNotificationPreferencesQuery';

export type NotificationItem = {
  id: string;
  category: NotificationCategoryKey;
  title: string;
  body: string;
  href: string | null;
  metadata: Record<string, unknown> | null;
  readAt: string | null;
  createdAt: string;
};

export type NotificationsListResponse = {
  items: NotificationItem[];
  unreadCount: number;
  nextCursor: string | null;
};

export const useNotificationsQuery = () => {
  const authStore = useAuthStore();

  return useQuery({
    queryKey: ['notifications', 'list'],
    queryFn: () =>
      $fetch<{ success: boolean; data: NotificationsListResponse }>(`/api/notifications`, {
        headers: { Authorization: `Bearer ${authStore.token}` },
      }),
    enabled: computed(() => !!authStore.token),
    select: (res) => res?.data ?? null,
    refetchInterval: 60_000,
    refetchIntervalInBackground: false,
    staleTime: 30_000,
    retry: false,
    throwOnError: false,
  });
};
